<template>
  <h2 class="pb-2 border-bottom">Terapia de Reemplazo Hormonal (HRT)</h2>
  <p>Atención Personalizada para Equilibrio y Vitalidad</p>
  <p>En Diverse Care Now, ofrecemos terapias hormonales seguras y supervisadas para hombres y mujeres. Nuestro objetivo es restaurar el equilibrio, aumentar la energía y mejorar el bienestar mediante planes personalizados.</p>
  <h3>Categorías</h3>
  <ul>
    <li>Mujeres: terapia con estrógeno & progesterona, hormonas bioidénticas, apoyo tiroideo.</li>
    <li>Hombres: reemplazo de testosterona (TRT), optimización de la tiroides, apoyo suprarrenal.</li>
    <li>Ambos: terapias con péptidos para vitalidad, apoyo suprarrenal y manejo del estrés.</li>
  </ul>
  <h3>Formas de administración</h3>
  <ul>
    <li>Inyecciones (semanales o quincenales).</li>
    <li>Pellets (liberación prolongada de 3–6 meses).</li>
    <li>Cremas/geles (uso diario).</li>
    <li>Medicamentos orales (menos comunes, usados en casos específicos).</li>
  </ul>
  <h3>Monitoreo & seguridad</h3>
  <ul>
    <li>Pruebas de laboratorio completas (hormonas, tiroides, marcadores metabólicos).</li>
    <li>Consulta inicial y planificación del tratamiento.</li>
    <li>Seguimiento continuo y ajustes de dosis.</li>
    <li>Consultas por telemedicina.</li>
  </ul>
  <p>“La terapia hormonal no es igual para todos — cada plan se adapta a sus necesidades únicas, siempre bajo supervisión médica.”</p>
</template>

<script>
export default {
  name: 'HormoneReplacementContentEs'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
